import React from 'react';
import { connect } from 'react-redux';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import DebouncedTextArea from 'components/shared/debouncedTextArea';
import sectionActions from '../../../actions/editor';
import * as lessonActions from '../../../actions/editor/lesson';

/**
 * @prop {func} onLessonTitleChange
 * @prop {func} onSectionTitleChange
 * @prop {string} lessonTitle
 * @prop {string} sectionTitle
 */
const SectionHeader = props => (
  <div className="Editor-header">
    <Text
      variant={TEXT_VARIANTS.TITLE}
      component={DebouncedTextArea}
      className="Editor-lessonTitle"
      placeholder="Lesson Title"
      onChange={props.onLessonTitleChange}
      value={props.lessonTitle}
      singleLine
      maxLength={255}
    />
    <Text
      variant={TEXT_VARIANTS.SUBHEADER_BOLD}
      component={DebouncedTextArea}
      className="Editor-sectionTitle"
      placeholder="Section Title"
      onChange={props.onSectionTitleChange}
      value={props.sectionTitle}
      singleLine
      maxLength={255}
    />
  </div>
);

const mapDispatchToProps = (dispatch, { id }) => ({
  onLessonTitleChange(title) {
    dispatch(lessonActions.requestUpdate(id, { title }));
  },
  onSectionTitleChange(title) {
    dispatch(sectionActions.requestUpdate(id, { title }));
  },
});

export default connect(null, mapDispatchToProps)(SectionHeader);
